import React from 'react';
import StunningCoralLogin from './components/StunningCoralLogin';
import './App.css';

function App() {
  return (
    <div className="App">
      <StunningCoralLogin />
    </div>
  );
}

export default App;
